<template>
	<div>
		<div class="mt-4 pt-4">
			<h1>Catalogue</h1>
			<div class="mt-4">
				<div class="row">
					<div class="col-12">
						<div class="card">
							<div class="card-header text-end">
								<button
									class="btn btn-outline-info"
									data-bs-toggle="modal"
									data-bs-target="#forms"
									v-on:click="refresh = Math.random(); catId = 0"
									id="triggerModals"
								>Create new catalogue</button>
							</div>
							<div class="card-body">
								<div class="table-responsive">
									<table class="table table-striped">
										<thead>
											<tr>
												<th>Title</th>
												<th># of reports</th>
												<th>Slug <small class="text-danger">[Scanner]</small></th>
												<th>Category</th>
												<th>Action</th>
											</tr>
										</thead>
										<tbody>
											<tr v-for="c in weakness" :key="c.ID">
												<td>{{ c.title }}</td>
												<td class="text-center">{{ c.reports }}</td>
												<td>{{ c.slug }}</td>
												<td>
													<router-link :to="'/admin/category/update/' + c.category_id">
														{{ c.category }}
													</router-link>
												</td>
												<td>
													<a href="javascript:void(0)"
													class="text-warning"
													data-bs-toggle="modal"
													data-bs-target="#forms"
													v-on:click="update(c.ID)">
														<i class="far fa-edit"></i>
													</a> |
													<a href="javascript:void(0)"
														class="text-danger"
														title="Delete"
														@click="deleteWeakness(c.ID)"
														v-if="c.reports == 0"
														>
														<i class="fa fa-trash"></i>
													</a>
													<i
														title="Catalogue contain reports"
														class="fa fa-trash" v-else></i>
												</td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="modal" id="forms" tabindex="-1">
			<div class="modal-dialog modal-lg">
				<div class="modal-content">
					<div class="modal-header">
						{{ catCallBack }} Catalogue
						<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" id="closeModal"></button>
					</div>
					<div class="modal-body">
						<Form v-on:callback="formCallback" :catId="catId" :key="refresh"/>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
  import Form from './CatalogueForm.vue'
    export default {
		components: {
			Form
		},
        data() {
            return {
                weakness: [],
                refresh: Math.random(),
                catId: 0,
                catCallBack: '',
            }
        },
        mounted() {
            this.init();
        },
        methods: {
            init() {
                const me = this;
                this.$axios({
                    method: 'get',
                    url: this.$server + 'weakness'
                })
                .then(res => {
                    var r = res.data;
                    if (r.success) {
                        me.weakness = r.data;
                    }
                });
            },

			update(id) {
				this.catId = id;
				this.refresh = Math.random();
			},

            formCallback(callback) {
				this.catCallBack = callback;
				if (callback == true) { // "need == true" as not empty value will return true
					document.getElementById("closeModal").click(); // manual close for a moment
					this.init();
				}
            },

            deleteWeakness(id){
                var c = confirm("Do you really want to delete this record?");
                if (c) {
                    // const me = this;
                    this.$axios({
                        method: 'delete',
                        url: `${this.$server}weakness/${id}`
                    })
                    .then(res => {
                        var r = res.data;
                        if (r.success) {
                            // reload data
                            this.init();
                        }
                    });
                }
            }
        },
    }
</script>